import { useContext } from 'react';
import { ThreadsApiContext } from './ThreadsApiContext';
import type { ThreadsApiClient } from './types';

export function useThreadsApiClient(): ThreadsApiClient {
  const client = useContext(ThreadsApiContext);
  if (client === null) {
    throw new Error(
      'useThreadsApiClient: no ThreadsApiProvider in the tree. ' +
        'Wrap the consumer in <ThreadsApiProvider client={...}>.',
    );
  }
  return client;
}
